<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items">
			<!-- <pre>{{item}}</pre> -->
			<div class="topBlock" :style='`background-image: url(${item.img})`'>
				<img :src="item.img" alt="">
			</div>
			<div class="description" v-if="item.description">
				{{item.description}}
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true,
				autoHeight:true
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.slider-detailPhoto {
  margin-bottom: 100px;
  @include m_up{
    margin-bottom: 54px;
  };
  .owl-carousel {
    position: relative;
    .item {
			.topBlock{
				border-radius: 7px;
				overflow: hidden;
				background-position: center;
				background-size: cover;
				img{
					display: block;
					border-radius: 7px;
					@include m_up{
						display: none;
					};
				}
				@include m_up{
					height: 380px;
				};
			}
			.description{
				padding: 25px 30px;
				border: 1px solid #e2edf3;
				margin: 30px 0 0 0;
				border-radius: 8px;
				position: relative;
				font-size: rem(15);
				line-height: rem(22);
				color: black;
				font-family: $ProximaNova_regular_italic;
				&:after{
					content: "";
					position: absolute;
					top: -12px;
					left: 30px;
					width: 12px;
					height: 18px;
					background-image: url('../img/arrow.jpg');
					background-size: cover;
					transform: rotate(90deg);
				}
			}
    }
    .owl-nav{
      font-size: 0;
      display: flex;
      justify-content:space-between;
      width: 100px;
      position: absolute;
      right: 0;
      bottom: -70px;
      top: auto;
      z-index: 11;
      @include m_up{
        top: calc(190px - 21px);
        bottom: auto;
        width: 100%;
      };
      div{
        width: 42px;
        height: 42px;
        border-radius: 100%;
        @include single-transition();
        background-size: 25px;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url('../img/arr.svg');
        border: 1px solid black;
        background-color: #fff;
        &:hover{
          background-image: url('../img/arr2.svg');
        }
      }
      .owl-prev{
        transform: rotate(90deg);
        position: relative;
        left: 0;
        @include m_up{
          left: -68px;
        };
      }
      .owl-next{
        transform: rotate(-90deg);
        position: relative;
        right: 0;
        @include m_up{
          right: -68px;
        };
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// detailPhoto.vue?45b334ac